import React from 'react'
import Yup from '../../../../../helpers/custom-yup'
import Title from '../../../../../components/typography/title.component'
import Button from '../../../../../components/buttons/buttons.component'
import STATES from '../../../../register/states'
import DatepickerInput from '../../../../../components/form-components/datepicker-input.component'
import InnerPageContainer from '../../../../../components/layout/private/inner-page-container.component'
import PaginationComponent from '../../../../../components/pagination/pagination.component'
import StyledInputContainer from '../../../../../components/form-components/styled-input-container.component'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { dateHelper } from './../../../../../helpers/date.helper'
import { maskHelper } from './../../../../../helpers/mask.helper'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../../actions'
import { paginationData } from './pagination-data'
import { bindActionCreators } from 'redux'
import { AdminReportsService } from './../../../../../services/admin-reports.service'
import { clientsReportActions } from './clients-report.actions'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { StyledForm, StyledSectionHeader } from './styles.style'
import {
	CPFInput,
	NumberInput,
	SelectInput,
	TextInput
} from '../../../../../components/form-components/inputs.component'

class ClientsReportPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.isExporting = false
		this.initialValues = {
			name: '',
			moveflexNumber: '',
			cpf: '',
			city: '',
			state: '',
			active: 'ACTIVE',
			dateStart: null,
			dateEnd: null,
			hasMuvicard: 'ALL'
		}
		this.schema = Yup.object().shape({
			name: Yup.string(),
			moveflexNumber: Yup.number().positive(),
			cpf: Yup.string(),
			city: Yup.string(),
			state: Yup.string(),
			active: Yup.string(),
			hasMuvicard: Yup.string()
		})
		this.state = {
			paginationData: {
				rows: paginationData,
				totalRows: paginationData.length
			},
			params: {}
		}
	}

	componentDidMount() {
		onSubmit.call(this, this.initialValues)
	}

	render() {
		return (
			<InnerPageContainer>
				<Title>Relatório de clientes</Title>
				<StyledSectionHeader>Filtros</StyledSectionHeader>
				<Formik
					initialValues={this.initialValues}
					onSubmit={onSubmit.bind(this)}
					validationSchema={this.schema}
					ref={'form'}
					render={props => (
						<StyledForm noValidate onSubmit={props.handleSubmit}>
							<div className="col1">
								<StyledInputContainer
									style={{ gridColumn: '0 / span 2' }}>
									<TextInput id="name" label="Nome" {...props} />
								</StyledInputContainer>
								<StyledInputContainer>
									<NumberInput
										id="moveflexNumber"
										label="Número Muviflex"
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<CPFInput id="cpf" label="CPF" {...props} />
								</StyledInputContainer>
								<StyledInputContainer>
									<SelectInput
										id="hasMuvicard"
										label="Possui Muvicard"
										defaultValue={{
											value: 'ALL',
											label: 'Todos'
										}}
										options={[
											{ label: 'Todos', value: 'ALL' },
											{ label: 'Sim', value: 'YES' },
											{ label: 'Não', value: 'NO' }
										]}
										multi={false}
										{...props}
									/>
								</StyledInputContainer>
							</div>
							<div className="col2">
								<StyledInputContainer
									style={{ gridColumn: '1 / span 2' }}>
									<TextInput id="city" label="Cidade" {...props} />
								</StyledInputContainer>
								<StyledInputContainer>
									<SelectInput
										id="state"
										label="UF"
										defaultValue={{
											value: '',
											label: 'Selecione...'
										}}
										options={STATES.map(({ Nome, Sigla }) => ({
											value: Sigla,
											label: Nome
										}))}
										multi={false}
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<SelectInput
										id="active"
										label="Situação"
										defaultValue={{
											value: 'ACTIVE',
											label: 'Ativos'
										}}
										options={[
											{ label: 'Todos', value: 'ALL' },
											{ label: 'Ativos', value: 'ACTIVE' },
											{ label: 'Inativos', value: 'INACTIVE' }
										]}
										multi={false}
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<DatepickerInput
										showClearDate
										id="dateStart"
										label="Data do cadastro início"
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<DatepickerInput
										showClearDate
										id="dateEnd"
										label="Data do cadastro fim"
										{...props}
									/>
								</StyledInputContainer>
							</div>
							<div
								style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<Button
									secondary
									style={{ marginRight: '15px' }}
									type="button"
									onClick={exportData.bind(this)}
									data-permission="A91F4748687AB6D6232B46A3387142B9F7CCC9AE">
									Exportar
								</Button>
								<Button
									data-permission="C05692C12B50B66B8C7F9A2DE8239E19CF6038E0"
									primary
									type="submit">
									Consultar
								</Button>
							</div>
						</StyledForm>
					)}
				/>
				<div
					style={{ marginTop: '20px', width: '100%' }}
					data-permission="C05692C12B50B66B8C7F9A2DE8239E19CF6038E0">
					<PaginationComponent
						ref="pagination"
						rowsPerPage={100}
						params={this.state.params}
						getData={AdminReportsService.searchClients}
						headers={[
							{
								header: 'Data de cadastro',
								key: 'creationDate',
								align: 'center'
							},
							{ header: 'Nome', key: 'name' },
							{ header: 'Número Muviflex', key: 'moveflexNumber' },
							{ header: 'CPF', key: 'cpf' },
							{ header: 'RG', key: 'rg' },
							{ header: 'E-mail', key: 'email' },
							{ header: 'Telefone', key: 'phone' },
							{ header: 'Muvicard', key: 'hasMuvicard' }
						]}
						sortable={{
							defaultOrder: 'desc',
							cols: [
								{ key: 'creationDate' },
								{ key: 'name' },
								{ key: 'moveflexNumber' },
								{ key: 'cpf' },
								{ key: 'rg' },
								{ key: 'email' },
								{ key: 'phone' },
								{ key: 'hasMuvicard' }
							]
						}}
						renderRow={(rowData, headers) => {
							return headers.map(({ key, align }) => (
								<td key={key} align={align}>
									<span title={rowData[key]}>
										{key == 'cpf'
											? maskHelper.applyCpf(rowData[key])
											: rowData[key]}
									</span>
								</td>
							))
						}}
					/>
				</div>
			</InnerPageContainer>
		)
	}
}

function onSubmit(values) {
	const { exportData, warning } = this.props

	const params = Object.assign({}, values)
	var { active, dateEnd, dateStart } = params

	const dateValidation = dateHelper.validateRange(dateStart, dateEnd)
	if (dateValidation.isNotValid) {
		warning(dateValidation)
		return
	}

	params.active = active === 'ALL' ? '' : active === 'ACTIVE'
	if (this.isExporting) {
		this.isExporting = false
		exportData(params)
	} else {
		this.setState({ params }, () => this.refs.pagination.reload())
	}
}

function exportData() {
	this.isExporting = true
	this.refs.form.submitForm()
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
			...clientsReportActions
		},
		dispatch
	)

const connectedClientsReportPageComponent = withRouter(
	connect(null, mapDispatchToProps)(ClientsReportPageComponent)
)

export { connectedClientsReportPageComponent as ModuleRootComponent }
